import React from 'react';
import PropTypes from 'prop-types';

import Barcode from 'react-barcode';
import QRCode from 'react-qr-code';

import { TEMPLATE_FIELD_TYPE, FGT_REDIRECT_BASE } from '../../constants';
import options from '../../utils/options';
import utils from '../../utils';

const sx = {
    field: { display: 'flex', lineHeight: '0.15in', minWidth: '100%', maxWidth: '100%' },
    column: { minWidth: '25%', maxWidth: '25%' },
    label: { fontSize: '7pt', minWidth: '35%', maxWidth: '35%', padding: '0 0 0 3px', whiteSpace: 'nowrap', overflow: 'hidden' },
    value: { fontSize: '7pt', minWidth: '60%', maxWidth: '60%', padding: '0 3px 0 3px', marginRight: '3px', fontWeight: 790, textAlign: 'left', whiteSpace: 'nowrap', overflow: 'hidden' },
    fieldsContainer: { display: 'flex', overflow: 'hidden', height: '0.75in', width: '11in', marginTop: '3px' },
    valueQrBcImg: { overflow: 'visible', maxWidth: '90%' },
};

const JobSheetLabelFields = ({ fields = [], rows = 5, hashId, partId }) => {

    const buildValue = (type, value) => {
        switch (type) {
            case TEMPLATE_FIELD_TYPE.BARCODE.value:
                return <Barcode width={1} height={7} displayValue={false} value={value} margin={0} />;
            case TEMPLATE_FIELD_TYPE.QR.value:
                if (value) {
                    return <QRCode size={66} value={value} />;
                }
                break;
            case TEMPLATE_FIELD_TYPE.IMG.value:
                return <img src={value} alt={value} />;
            case TEMPLATE_FIELD_TYPE.DATE.value:
                return <span>{options.getDate(value, TEMPLATE_FIELD_TYPE.DATE.value)}</span>;
            case TEMPLATE_FIELD_TYPE.DATE_TIME.value:
                return <span>{options.getDate(value, TEMPLATE_FIELD_TYPE.DATE_TIME.value)}</span>;
            default:
                return <span>{value}</span>;
        }
    };

    const buildField = ({ label, value, type, id }, hashId, partId) => {
        const array = label.split('] - ');

        const isSpeedLink = () => id === 'speed-link' && hashId && partId;

        const fieldValue = isSpeedLink() ? `${FGT_REDIRECT_BASE}/${hashId}/${partId}` : value;

        return (
            <div style={sx.field} key={id}>
                <div style={sx.label}>{array[array?.length - 1]}</div>
                <div style={{ ...sx.value, ...type === 'qr' || type === 'bc' || type === 'img' ? sx.valueQrBcImg : {} }}>
                    {buildValue(type, fieldValue)}
                </div>
            </div>
        );
    };

    const filtered = utils.array.chunk(fields, rows);

    return (
        <div style={sx.fieldsContainer}>
            {filtered.map((f, idx) => (
                <div style={sx.column} key={idx}>
                    {f.map((f) => buildField(f, hashId, partId))}
                </div>
            ))}
        </div>
    );
};

JobSheetLabelFields.propTypes = {
    fields: PropTypes.array.isRequired,
    rows: PropTypes.number,
    hashId: PropTypes.string,
    partId: PropTypes.string,
};

export default JobSheetLabelFields;
